import { combineEpics } from 'redux-observable';

import { _reducer } from './auth.reducers';
import _authEpics from './auth.epics';

export const _epics = combineEpics(_authEpics);
export { _reducer };
export * from './auth.actions';
